import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "./constants";

export const magazineApi = createApi({
  reducerPath: "magazine/api",
  tagTypes: ['Magazines'],
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const { token } = getState().users;
      headers.set("Content-Type", "application/json");
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (build) => ({
    getAllMagazineEvents: build.query({
      query: (params) => {
        const stringParams = Object.entries(params).reduce(
          (acc, [key, value]) => `${acc ? acc + "&" : ""}${key}=${value}`,
          ""
        );
        return {
          url: `api/logs/get-event-log-list-disp?${stringParams}`,
        };
      },
      providesTags: ['Magazines']
    }),
  }),
});

export const { useLazyGetAllMagazineEventsQuery } = magazineApi;
